var o = /* @__PURE__ */ ((r) => (r.LIGHT = "light", r.DARK = "dark", r))(o || {}), A = /* @__PURE__ */ ((r) => (r.REOLINK = "reolink", r.CAMOVUE = "camovue", r.KEEN = "camovue", r))(A || {}), u = /* @__PURE__ */ ((r) => (r.BUTTON = "button", r.BALLOON = "balloon", r.CHECKBOX = "checkbox", r.INPUT = "input", r.MEASURE_INPUT = "measureInput", r.TEXTAREA = "textarea", r.LINK = "link", r.POPUP = "popup", r.RADIO_GROUP = "radioGroup", r.SELECT = "select", r.TABS = "tabs", r.TAG = "tag", r.UPLOAD = "upload", r.DRAGGED_UPLOAD = "draggedUpload", r.FORM = "form", r.MESSAGE = "message", r))(u || {});
export {
  A as EScene,
  o as ETheme,
  u as EThemeTemplate
};
//# sourceMappingURL=type.mjs.map
